import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export enum EpicGroupTypesEnum {
  All = 'All',
  Products = 'Products',
  CostTypes = 'CostTypes',
}

export const useTypeOptions = () => {
  const { t } = useTranslation(undefined, { keyPrefix: 'projects.constructor' });

  return useMemo(
    () => [
      { label: `${t('addEpicGroups.types.product')}`, value: EpicGroupTypesEnum.Products },
      { label: `${t('addEpicGroups.types.cost')}`, value: EpicGroupTypesEnum.CostTypes },
    ],
    [t],
  );
};
